/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { ModelUtils } from '../util/ModelUtils';
import { Document } from '../../core/models/Document';
import { Extension } from '../../core/models/Extension';
import { OasDocument } from '../../openapi/models/OasDocument';
import { Oas20Document } from '../../openapi/v2/models/Oas20Document';
import { Oas30Document } from '../../openapi/v3/models/Oas30Document';
import { ReplaceNodeCommand } from './ReplaceNodeCommand';
import { DocumentType } from '../../core/models/DocumentType';

/**
 * A command used to replace a path item with a newer version.
 * @author eric.wittmann@gmail.com
 * @extends ReplaceNodeCommand
 * @class
 */
export class ReplaceDocumentCommand extends ReplaceNodeCommand<Document> {
    public constructor(old? : any, replacement? : any) {
        if(((old != null && old instanceof <any>Document) || old === null) && ((replacement != null && replacement instanceof <any>Document) || replacement === null)) {
            let __args = arguments;
            super(old, replacement);
        } else if(old === undefined && replacement === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    public removeNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_core_models_Document(doc : Document, node : Document) {
        switch((node.getDocumentType())) {
        case DocumentType.asyncapi2:
            this.resetAai2xDocument(<Aai20Document>node);
            break;
        case DocumentType.openapi2:
            this.resetOas2xDocument(<Oas20Document>node);
            break;
        case DocumentType.openapi3:
            this.resetOas3xDocument(<Oas30Document>node);
            break;
        default:
            break;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.ReplaceNodeCommand#removeNode(io.apicurio.datamodels.core.models.Document, io.apicurio.datamodels.core.models.Node)
     * @param {Document} doc
     * @param {Document} node
     */
    public removeNode(doc? : any, node? : any) : any {
        if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null && node instanceof <any>Document) || node === null)) {
            return <any>this.removeNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_core_models_Document(doc, node);
        } else if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null) || node === null)) {
             throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)'); 
        } else throw new Error('invalid overload');
    }

    public addNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_core_models_Document(doc : Document, node : Document) {
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.ReplaceNodeCommand#addNode(io.apicurio.datamodels.core.models.Document, io.apicurio.datamodels.core.models.Node)
     * @param {Document} doc
     * @param {Document} node
     */
    public addNode(doc? : any, node? : any) : any {
        if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null && node instanceof <any>Document) || node === null)) {
            return <any>this.addNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_core_models_Document(doc, node);
        } else if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null) || node === null)) {
             throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)'); 
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.ReplaceNodeCommand#readNode(io.apicurio.datamodels.core.models.Document, java.lang.Object)
     * @param {Document} doc
     * @param {*} node
     * @return {Document}
     */
    readNode(doc : Document, node : any) : Document {
        Library.readNode(node, doc);
        return <Document>doc;
    }

    /**
     * Resets a 2.0 OAI document by nulling out all of its properties.
     * @param {Oas20Document} doc
     * @private
     */
    /*private*/ resetOas2xDocument(doc : Oas20Document) {
        doc.host = null;
        doc.basePath = null;
        doc.schemes = null;
        doc.consumes = null;
        doc.produces = null;
        doc.definitions = null;
        doc.parameters = null;
        doc.responses = null;
        doc.securityDefinitions = null;
        this.resetOasDocument(doc);
    }

    /**
     * Resets a 3.x OAI document by nulling out all of its properties.
     * @param {Oas30Document} doc
     * @private
     */
    /*private*/ resetOas3xDocument(doc : Oas30Document) {
        doc.servers = null;
        doc.components = null;
        this.resetOasDocument(doc);
    }

    /**
     * Resets a 2.0 AAI document by nulling out all of its properties.
     * @param {Aai20Document} doc
     * @private
     */
    /*private*/ resetAai2xDocument(doc : Aai20Document) {
        doc.id = null;
        doc.channels = <any>({});
        doc.servers = null;
        doc.components = null;
        doc.defaultContentType = null;
        this.resetDocument(doc);
    }

    /**
     * Resets the common properties of an OAS doc.
     * @param {OasDocument} doc
     * @private
     */
    /*private*/ resetOasDocument(doc : OasDocument) {
        doc.paths = null;
        doc.security = null;
        this.resetDocument(doc);
    }

    /**
     * Resets the common properties.
     * @param {Document} doc
     * @private
     */
    /*private*/ resetDocument(doc : Document) {
        doc.info = null;
        doc.tags = null;
        doc.externalDocs = null;
        let extensions : Array<Extension> = doc.getExtensions();
        if(ModelUtils.isDefined(extensions)) {
            extensions.forEach((ext) => {
                doc.removeExtension(ext.name);
            });
        }
        doc.getExtraPropertyNames().forEach((pname) => {
            doc.removeExtraProperty(pname);
        });
    }
}
ReplaceDocumentCommand["__class"] = "io.apicurio.datamodels.cmd.commands.ReplaceDocumentCommand";
ReplaceDocumentCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




